/** biome-ignore-all lint/correctness/noUnusedImports: reason */

import React from "react";
import { Dimmer, Loader } from "semantic-ui-react";

import { debugError, debugLog } from "../helpers/debug";

const LoadingComponent = ({
  inverted,
  loading,
  error,
  pastDelay,
  timedOut,
}) => {
  // Debug logging for react-loadable states
  debugLog("[LoadingComponent] Props:", {
    error,
    loading,
    pastDelay,
    timedOut,
  });

  // Handle error state
  if (error) {
    debugError("[LoadingComponent] Error loading chunk:", error);

    return (
      <div
        style={{
          padding: "20px",
          textAlign: "center",
        }}
      >
        <p>Error loading page. Please refresh.</p>

        <button
          onClick={() => window.location.reload()}
          type="button"
        >
          Refresh
        </button>
      </div>
    );
  }

  // Handle timeout state
  if (timedOut) {
    return (
      <div
        style={{
          padding: "20px",
          textAlign: "center",
        }}
      >
        <p>Loading timed out. Please refresh.</p>
        <button
          onClick={() => window.location.reload()}
          type="button"
        >
          Refresh
        </button>
      </div>
    );
  }

  // Only show loading if actually loading
  if (loading) {
    return (
      <Dimmer
        active={true}
        inverted={inverted}
      >
        <Loader content="Loading..." />
      </Dimmer>
    );
  }

  // Component loaded, return null
  return null;
};

export default LoadingComponent;
